const gender = [
  { label: 'Herr', value: 'MALE' },
  { label: 'Frau', value: 'FEMALE' }
]

export default gender
